// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import Diet__FormTotalWeightController from "./diet/form_total_weight_controller";
application.register(
  "diet--form-total-weight",
  Diet__FormTotalWeightController
);

import Transaction__FormController from "./transaction/form_controller";
application.register("transaction--form", Transaction__FormController);

import Ui__CleanupController from "./ui/cleanup_controller";
application.register("ui--cleanup", Ui__CleanupController);

import Ui__AreaChartController from "./ui/area_chart_controller";
application.register("ui--area-chart", Ui__AreaChartController);

import Ui__ColumnChartController from "./ui/column_chart_controller";
application.register("ui--column-chart", Ui__ColumnChartController);

import Ui__DropdownController from "./ui/dropdown_controller";
application.register("ui--dropdown", Ui__DropdownController);

import Ui__MobileMenuController from "./ui/mobile_menu_controller";
application.register("ui--mobile-menu", Ui__MobileMenuController);

import Ui__ImageGalleryController from "./ui/image_gallery_controller";
application.register("ui--image-gallery", Ui__ImageGalleryController);

import Ui__ModalController from "./ui/modal_controller";
application.register("ui--modal", Ui__ModalController);

import Ui__PhotoPreviewController from "./ui/photo_preview_controller";
application.register("ui--photo-preview", Ui__PhotoPreviewController);

import Ui__PieChartController from "./ui/pie_chart_controller";
application.register("ui--pie-chart", Ui__PieChartController);
